<template>
	<div class="pos-rel">
		<analytics-el-img
			:SM="SM"
			:src="src"
			:post="post"
			:isFullView="isFullView"
			:bypassPreFetch="bypassPreFetch"
			:preFetchImages="preFetchImages"
		/>
		<h6
			class="full-width text-ellipsis py-2 px-3 ma-0 subheading post-description"
		>
			{{ linkDesc }}
		</h6>
	</div>
</template>

<script>
import AnalyticsElImg from "./img"

export default {
	name: "AnalyticsElNewsLink",
	props: [
		"SM",
		"src",
		"linkDesc",
		"post",
		"isFullView",
		"bypassPreFetch",
		"preFetchImages"
	],
	components: {
		"analytics-el-img": AnalyticsElImg
	}
}
</script>

<style lang="scss" scoped>
.post-description {
	position: absolute;
	top: auto;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(255, 255, 255, 0.8);
}
</style>
